import kebabCase from 'lodash-es/kebabCase';
import * as React from 'react';
import ReactDOM from 'react-dom';

import fakeContext from 'mk/common/fluxible/fakeContext';
import {AdSlot} from 'mk/ox/AdSlot';
import {AdSlotOffsite} from 'mk/ox/AdSlotOffsite';
import {AdSlotSticky} from 'mk/ox/AdSlotSticky';

const COMPONENTS = { AdSlot, AdSlotSticky, AdSlotOffsite };

export function reactInit() {
    // Find all elements with data-ox-react
    let elements = document.querySelectorAll('[data-ox-react]');
    for (let i = 0; i < elements.length; i++) {
        mount(elements[i]);
    }
}

function mount(element) {
    let component = data(element, 'component');
    let zoneName = data(element, 'zoneName');
    let className = data(element, 'className');

    let ReactComponent = COMPONENTS[component];
    ReactDOM.render(
        <ReactComponent zoneName={zoneName} className={className} context={fakeContext()} />,
        element
    );
}

function data(element, name) {
    let elementData = (element.dataset && element.dataset[name]) || element.getAttribute(`data-${kebabCase(name)}`);
    try {
        return JSON.parse(elementData);
    } catch (e) {
        return elementData;
    }
}
